import Vue from "vue";
import VueRouter from "vue-router";
import Home from "../views/home.vue";
import ProofDetail from "../views/proofDetail.vue";
import repeatOrder from "../views/repeatOrder.vue";

Vue.use(VueRouter);

const routes = [
    //首页
    {
        path: "/",
        name: "Home",
        component: Home,
    },
    {
        path: "/proofDetail",
        name: "ProofDetail",
        component: ProofDetail,
    }, 
    {
        path: "/repeatOrder",
        name: "repeatOrder",
        component: repeatOrder,
    },
];

const router = new VueRouter({
    mode: "history",
    //   base: process.env.BASE_URL,
    routes,
});

export default router;